import { FileText, Handshake, Truck } from 'lucide-react';

import { BrokerageLayout } from './_components/_layouts/BrokerageLayout';
import { BrokeredLoadDetailView } from './_components/loads/_BrokeredLoadDetailView';
import { BrokeredLoadsListView } from './_components/loads/_BrokeredLoadsListView';
import { BrokeredOrderDetailView } from './_components/orders/_BrokeredOrderDetailView';
import { BrokeredOrderListView } from './_components/orders/_BrokeredOrderListView';
import { QuoteDetailView } from './_components/quotes/_QuoteDetailView';
import { QuoteListView } from './_components/quotes/_QuoteListView';

import { createAppModule } from '~/shared/routing/createAppModule';
import { createModuleNav } from '~/shared/routing/createModuleNav';
import { createModuleRoutes } from '~/shared/routing/createModuleRoutes';

const basePath = '/brokerage';

export const brokerageRoutes = createModuleRoutes({
  root: {
    path: basePath,
    label: (t) => t.menu.brokerage.root,
    icon: Handshake,
  },
  orders: {
    path: `${basePath}/orders`,
    label: (t) => t.menu.brokerage.orders,
    icon: FileText,
    component: BrokeredOrderListView,
    requiredPermission: 'brokeredOrderRead',
  },
  orderDetail: {
    path: `${basePath}/orders/:id`,
    component: BrokeredOrderDetailView,
  },
  quotes: {
    path: `${basePath}/quotes`,
    label: (t) => t.menu.brokerage.quotes,
    icon: FileText,
    component: QuoteListView,
    requiredPermission: 'quoteRead',
  },
  quoteDetail: {
    path: `${basePath}/quotes/:id`,
    component: QuoteDetailView,
  },
  loads: {
    path: `${basePath}/loads`,
    label: (t) => t.menu.brokerage.loads,
    icon: Truck,
    component: BrokeredLoadsListView,
    requiredPermission: 'purchaseLoadRead',
  },
  loadDetail: {
    path: `${basePath}/loads/:id`,
    component: BrokeredLoadDetailView,
  },
});

// prettier-ignore
const brokerageNav = createModuleNav(($) =>
  $(brokerageRoutes.root, [
    $(brokerageRoutes.quotes),
    $(brokerageRoutes.quoteDetail),
    $(brokerageRoutes.orders),
    $(brokerageRoutes.orderDetail),
    $(brokerageRoutes.loads),
    $(brokerageRoutes.loadDetail),
  ]),
);

export const brokerageModule = createAppModule({
  routes: brokerageRoutes,
  nav: brokerageNav,
  layout: BrokerageLayout,
});
